/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M4 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 4 6ZM4.75 10.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM19.4992 13.4402a.7502.7502 0 0 1 .0606 1.059l-3.3883 3.7997c-.3861.433-1.0584.4476-1.463.0319l-2.246-2.3077a.75.75 0 0 1 1.075-1.0462L15.4092 16.9l3.031-3.3992a.7502.7502 0 0 1 1.059-.0606Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 2.75C0 1.2312 1.2312 0 2.75 0h11c1.5188 0 2.75 1.2312 2.75 2.75v5.2654C20.6854 8.2734 24 11.7496 24 16c0 4.4183-3.5817 8-8 8-3.1639 0-5.8987-1.8366-7.1967-4.5019A.7243.7243 0 0 1 8.75 19.5h-6C1.2312 19.5 0 18.2688 0 16.75v-14ZM8.252 18A8.0142 8.0142 0 0 1 8 16c0-4.0796 3.0537-7.446 7-7.9381V2.75c0-.6904-.5596-1.25-1.25-1.25h-11c-.6904 0-1.25.5596-1.25 1.25v14c0 .6904.5596 1.25 1.25 1.25h5.502ZM22.5 16c0 3.5899-2.9101 6.5-6.5 6.5S9.5 19.5899 9.5 16s2.9101-6.5 6.5-6.5 6.5 2.9101 6.5 6.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuTesting'
);
